<template>
  <div
    v-if="compareItems.length"
    class="p-4 bg-white flex gap-3 w-full shadow-md bottom-0 justify-center z-3 <lg:flex-col lg:gap-4"
    :class="{ fixed: $viewport.lg || isPLP }"
  >
    <base-grid class="gap-2 grid cols-4 max-w-fit self-center">
      <template v-for="product in compareItems" :key="product.id">
        <span class="flex flex-col justify-center">
          <div class="w-full relative">
            <base-picture
              :alt="product.gallery?.[0].alt"
              class="h-full <lg:w-full lg:!h-$h"
              :src="product.gallery?.[0].src!"
              :style="{
                'aspect-ratio': gallery.presets.src.width / gallery.presets.src.height,
                '--h': '6.875rem',
              }"
            />
            <base-button @click="$emit('remove', product.styleId || product.id)">
              <vf-icon class="cursor-pointer right-0 top-0 absolute" name="close" size="md" style="padding: 2px" />
            </base-button>
          </div>
        </span>
      </template>
      <div v-for="i in (4 - compareItems.length)" :key="i">
        <div class="bg-grey-90 flex flex-col w-full items-center justify-center" :style="{ 'aspect-ratio': gallery.presets.src.width / gallery.presets.src.height }" />
      </div>
    </base-grid>
    <div class="flex gap-2 justify-center lg:flex-col">
      <base-button class="text-sm c-grey-10 fw-700 flex <lg:grow" @click="DialogCompare.open()">
        {{ $t.compareItems }} {{ compareItems.length }}/4
        <vf-icon class="ml-1" name="arrow" />
      </base-button>
      <base-button class="text-sm underlined" @click="cancel">
        {{ $t.cancel }}
      </base-button>
    </div>
  </div>
  <dialog-compare />
</template>

<script lang="ts" setup>
defineEmits<Emits>()

export type Emits = {
  remove: [payload: string]
}
const { $viewport } = useNuxtApp()
const { compareItems } = storeToRefs(useCompareStore())
const { cancel } = useCompareStore()
const { gallery } = useAppConfig().pages?.pdp || {}
const route = useRoute()

const isPLP = computed(() => route.path.includes('/c/'))

const DialogCompare = createDialog('compare', {
  type: () => $viewport.lg ? 'modal' : 'panel',
  size: 'lg'
})
</script>
